export default "__VITE_ASSET__qX2kJIUl__"